/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved.
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export interface LauncherWebviewClient {
  goToLoginPage(): Promise<string>;
  getCurrentLocale(): Promise<string>;
  onLocaleChange(localeChangeListener: (lang: string) => void): void;
  changeLanguage(lang: string): Promise<void>;
}

export function getLauncherWebviewClient() {
  try {
    // Handling when Player Portal opened in a iframe inside launcher webview
    const client = window && ((window.top as any).JusticeLauncherWebviewClient as LauncherWebviewClient | undefined);
    return client;
  } catch (error) {
    return undefined;
  }
}

export function isInLauncher() {
  return !!getLauncherWebviewClient();
}

export async function withLauncherWebviewClient<T>(
  func: (launcherWebviewClient: LauncherWebviewClient) => T | null
): Promise<T | null> {
  const launcherWebviewClient = getLauncherWebviewClient();
  if (!launcherWebviewClient) return null;
  return await func(launcherWebviewClient);
}
